<template>
  <div id="innerContent" class="mx-5">
    <div v-if="loading" class="min-vh-100 d-flex align-items-center justify-content-center">
      <Loading />
    </div>
    <div v-else class="form-row w-100 d-flex align-items-end justify-content-end">
      <div>
        <b-alert :show="officeFlag" variant="warning" class="text-xs mb-4">
            Please create an office before assigning an user
        </b-alert>
        <button :disabled="officeFlag" v-b-modal.new-user class="btn btn-primary">
          <b-icon-plus></b-icon-plus>
          Add user
        </button>
      </div>
      <div class="col-auto mb-1">
        <b-modal
          id="new-user"
          ref="modal"
          @show="resetModal"
          @hidden="resetModal"
          @shown="initFormlessFloatingLabels()"
          @ok="addUser"
        >
          <template v-slot:modal-title>
            Add User
          </template>
          <template v-slot:default>
            <div v-if="error" class="d-flex align-items-center justify-content-center">
              <div style="max-width: 400px;">
                <h6 class="text-2xl text-red-500 font-weight-bold">
                  An error has occured
                </h6>
              </div>
            </div>
            <!-- <form ref="first" @submit.stop.prevent="addUser">
              <b-form-group
                  label="First Name"
                  label-for="first-input"
                  :state="userState.firstState"
              >
                <b-form-input
                  id="first-input"
                  v-model="user.first"
                  :state="userState.firstState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="last" @submit.stop.prevent="addUser">
              <b-form-group
                  label="Last Name"
                  label-for="last-input"
                  :state="userState.lastState"
              >
                <b-form-input
                  id="last-input"
                  v-model="user.last"
                  :state="userState.lastState"
                  required
                ></b-form-input>
              </b-form-group>
            </form> -->

            <form ref="email" @submit.stop.prevent="addUser">
              <b-form-group
                label="Email"
                label-for="email-input"
                :state="userState.emailState"
              >
                <b-form-input
                  id="email-input"
                  type="email"
                  v-model="user.email"
                  :state="userState.emailState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <!-- <form ref="password" @submit.stop.prevent="addUser">
              <b-form-group
                  label="Password"
                  label-for="password-input"
                  :state="userState.passwordState"
              >
                <b-form-input
                  id="password-input"
                  v-model="user.password"
                  :state="userState.passwordState"
                  required
                ></b-form-input>
              </b-form-group>
            </form> -->

            <form ref="role" @submit.stop.prevent="addUser">
              <b-form-group
                  label="Role"
                  label-for="role-input"
                  :state="userState.roleState"
              >
                <b-form-select
                    required
                    v-model="user.role"
                    :options="roleOptions"
                    :state="userState.roleState"
                    class="mb-3 normalize-input"
                    style=" text-align-last: center; font-size: small;"
                ></b-form-select>
              </b-form-group>
            </form>

            <form ref="office" @submit.stop.prevent="addUser">
              <b-form-group
                  label="Office Branch"
                  label-for="office-input"
                  :state="userState.officeState"
              >
                <b-form-select
                    required
                    v-model="user.office"
                    :options="officeOptions"
                    :state="userState.officeState"
                    class="mb-3 normalize-input"
                    style=" text-align-last: center; font-size: small;"
                ></b-form-select>
              </b-form-group>
            </form>

            <form ref="title" @submit.stop.prevent="addUser">
              <b-form-group
                  label="Title"
                  label-for="title-input"
                  :state="userState.titleState"
              >
                <b-form-input
                  id="title-input"
                  v-model="user.title"
                  :state="userState.titleState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>
          </template>
        </b-modal>
      </div>
    </div>
  <hr/>
  <table class="table table-hover" v-cloak>
    <thead>
    <tr>
      <th scope="col">Name
          <button @click="orderByName = !orderByName" class="btn btn-light">
            <div v-if="orderByName">
              <b-icon-arrow-down-short></b-icon-arrow-down-short>
            </div>
            <div v-else>
              <b-icon-arrow-up-short></b-icon-arrow-up-short>
            </div>
          </button>
      </th>
      <th scope="col">Email</th>
      <th scope="col">Role</th>
      <th scope="col">Office Branch</th>
      <th scope="col">Title/Function</th>
      <th scope="col">Actions</th>
    </tr>
    </thead>
    <tbody>
      <tr v-for="(result) in namesOrdered" :key="result.id">
        <!-- <th scope="row">{{ result.id }}</th> -->
        <td>{{ result.name }}</td>
        <td>{{ result.email }}</td>
        <!-- <td>{{ result.username }}</td> -->
        <td>{{ result.role }}</td>
        <td>{{ getOfficeValue(result.office) }}</td>
        <td>{{ result.title }}</td>
        <td>
          <button v-if="!result.authenticated"
            v-b-modal.resend-email @click="selected(result)" class="btn btn-warning">
              <b-icon-envelope></b-icon-envelope>
          </button>

          <button v-if="currentUser.roles !== 'Owner' ? disableAction(result.role) : true"
            v-b-modal.edit-user @click="selected(result)" class="btn btn-success">
            <b-icon-pencil></b-icon-pencil>
          </button>

          <button v-if="currentUser.roles !== 'Owner' ? disableAction(result.role) : true"
            v-b-modal.delete-user
            @click="selected(result)" class="btn btn-danger">
              <b-icon-trash></b-icon-trash>
          </button>

        </td>
      </tr>
    </tbody>
  </table>
  <b-modal
    id="edit-user"
    ref="editmodal"
    @show="resetModal"
    @hidden="resetModal"
    @shown="initFormlessFloatingLabels()"
    @ok="tabIndex==0 ? edit($event) : updatePermission($event)"
  >
    <!-- <template v-slot:modal-title>
      Edit User
    </template> -->
    <template v-slot:default>
      <div>
        <b-tabs v-model="tabIndex" content-class="mt-3">
          <b-tab title="Edit User" active >
            <div v-if="error" class="d-flex align-items-center justify-content-center">
              <div style="max-width: 400px;">
              <h6 class="text-2xl text-red-500 font-weight-bold">
                An error has occured
              </h6>
              </div>
            </div>
            <form ref="first" @submit.stop.prevent="edit">
              <b-form-group
                  label="First Name"
                  label-for="first-input"
                  :state="userState.firstState"
              >
                <b-form-input
                  id="first-input"
                  v-model="selectedUser.first"
                  :state="userState.firstState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="last" @submit.stop.prevent="edit">
              <b-form-group
                  label="Last Name"
                  label-for="last-input"
                  :state="userState.lastState"
              >
                <b-form-input
                  id="last-input"
                  v-model="selectedUser.last"
                  :state="userState.lastState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="email" @submit.stop.prevent="edit">
              <b-form-group
                label="Email"
                label-for="email-input"
                :state="userState.emailState"
              >
                <b-form-input
                  readonly
                  id="email-input"
                  type="email"
                  v-model="selectedUser.email"
                  :state="userState.emailState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>

            <form ref="role" @submit.stop.prevent="edit">
              <b-form-group
                  label="Role"
                  label-for="role-input"
                  :state="userState.roleState"
              >
                <b-form-select
                    required
                    v-model="selectedUser.role"
                    :options="roleOptions"
                    :state="userState.roleState"
                    class="mb-3 normalize-input"
                    style=" text-align-last: center; font-size: small;"
                ></b-form-select>
              </b-form-group>
            </form>

            <form ref="office" @submit.stop.prevent="edit">
              <b-form-group
                  label="Office Branch"
                  label-for="office-input"
                  :state="userState.officeState"
              >
                <b-form-select
                    required
                    v-model="selectedUser.office"
                    :options="officeOptions"
                    :state="userState.officeState"
                    class="mb-3 normalize-input"
                    style=" text-align-last: center; font-size: small;"
                ></b-form-select>
              </b-form-group>
            </form>

            <form ref="title" @submit.stop.prevent="edit">
              <b-form-group
                  label="Title"
                  label-for="title-input"
                  :state="userState.titleState"
              >
                <b-form-input
                  id="title-input"
                  v-model="selectedUser.title"
                  :state="userState.titleState"
                  required
                ></b-form-input>
              </b-form-group>
            </form>
          </b-tab>
          <b-tab title="Edit Permission">
            <component
            :is="componentMap[selectedUser.role]"
            :permissions="selectedUser.permissions"
          ></component>
            <!-- <div v-if="selectedUser.role == 'Admin'">
              <PermissionAdmin :permissions="selectedUser.permissions" />
            </div>
            <div v-else-if="">
              <PermissionStaffExporter :permissions="selectedUser.permissions" />
            </div> -->
          </b-tab>
        </b-tabs>
      </div>
    </template>
    <!-- <template #modal-footer="{ ok }">
        <b-button variant="success" @click="ok()">
          OK
        </b-button>
    </template> -->
  </b-modal>

   <b-modal
    id="delete-user"
    ref="deletemodal"
    @show="resetModal"
    @hidden="resetModal"
    @shown="initFormlessFloatingLabels()"
    @ok="remove()"
  >
    <template v-slot:modal-title>
      Delete Confirmation
    </template>
    <template v-slot:default>
      <div>
        <div v-if="error" class="d-flex align-items-center justify-content-center">
          <div style="max-width: 400px;">
            <h6 class="text-2xl text-red-500 font-weight-bold">
              An error has occured
            </h6>
          </div>
        </div>
        <h5 class="font-weight-bold">
          Are you sure you want to delete this user?
        </h5>
      </div>
    </template>
    <!-- <template #modal-footer="{ ok }">
        <b-button variant="success" @click="ok()">
          OK
        </b-button>
    </template> -->
  </b-modal>

  <b-modal
    id="resend-email"
    ref="resendmodal"
    @show="resetModal"
    @hidden="resetModal"
    @shown="initFormlessFloatingLabels()"
    @ok="resend()"
  >
    <template v-slot:modal-title>
      Resend email Confirmation
    </template>
    <template v-slot:default>
      <div>
        <div v-if="error" class="d-flex align-items-center justify-content-center">
          <div style="max-width: 400px;">
            <h6 class="text-2xl text-red-500 font-weight-bold">
              An error has occured
            </h6>
          </div>
        </div>
        <h5 class="font-weight-bold">
          Are you sure you want to resend confirmation link to this user?
        </h5>
      </div>
    </template>
  </b-modal>
  </div>
</template>

<script>
import Fuse from 'fuse.js';
import Loading from '../components/Loading.vue';
import PermissionAdmin from '../components/PermissionAdmin.vue';
import PermissionStaffExporter from '../components/PermissionOfficeStaffExporter.vue';
import PermissionStaffImporter from '../components/PermissionOfficeStaffImporter.vue';
import PermissionTransportSpecialistExporter from '../components/PermissionTransportSpecialistExporter.vue';
import PermissionTransportSpecialistImporter from '../components/PermissionTransportSpecialistImporter.vue';
import {
  postUser, getUser, deleteUser, editUser,
  editPermission, getOffice, emailresend,
} from '../api/admin';

export default {
  name: 'roleSetting',
  data() {
    return {
      componentMap: {
        Admin: 'PermissionAdmin',
        'Agent–Exporter': 'PermissionStaffExporter',
        'Agent-Importer': 'PermissionStaffImporter',
        'Transport Specialist–Exporter': 'PermissionTransportSpecialistExporter',
        'Transport Specialist–Importer': 'PermissionTransportSpecialistImporter',
      },
      tabIndex: 0,
      selectedIndex: -1,
      selectedUser: {},
      loading: true,
      officeFlag: true,
      search: '',
      orderByName: true,
      error: false,
      results: [],
      currentUser: '',
      user: {
        name: '',
        first: '',
        last: '',
        email: '',
        office: '',
        title: '',
        role: '',
        password: '',
      },
      userState: {
        nameState: null,
        firstState: null,
        lastState: null,
        emailState: null,
        officeState: null,
        titleState: null,
        roleState: null,
        passwordState: null,
      },
      permissions: [
        { key: 'User Setting', value: [{ value: 'manage', name: 'Admin Account' }] },
        { key: 'Shipment Booking & Status', value: [{ value: 'manage', name: 'Booking Details' }] },
        { key: 'User Booking', value: [{ value: 'manage', name: 'Booking Details' }] },
      ],
      roleOptions: [
        { value: '', text: '---', disabled: true },
        { value: 'Admin', text: 'Admin' },
        { value: 'Agent–Exporter', text: 'Agent–Exporter' },
        { value: 'Agent-Importer', text: 'Agent-Importer' },
        { value: 'Transport Specialist–Exporter', text: 'Transport Specialist–Exporter' },
        { value: 'Transport Specialist–Importer', text: 'Transport Specialist–Importer' },
      ],
      officeOptions: [
        {
          id: -1, value: '', text: '---', disabled: true,
        },
      ],
    };
  },
  computed: {
    namesOrdered() {
      if (this.orderByName) {
        return this.results.concat().sort((a, b) => a.name.localeCompare(b.name));
      }
      return this.results.concat().sort((a, b) => b.name.localeCompare(a.name));
    },
    fuse() {
      return new Fuse(this.results, {
        keys: ['name', 'first', 'last', 'email', 'username', 'role', 'office', 'title'],
        useExtendedSearch: true,
      });
    },
  },
  methods: {
    disableAction(role) {
      return role !== 'Owner' && role !== 'Admin';
    },
    getOfficeValue(id) {
      const value = this.officeOptions.filter((item) => item.value === parseInt(id, 10));
      if (value.length !== 0) {
        return value[0].text;
      }
      return '';
    },
    updatePermission(bvModalEvt) {
      bvModalEvt.preventDefault();
      const copy = Object.keys(this.selectedUser).reduce((acc, curr) => {
        if (typeof this.selectedUser[curr] === 'string') {
          acc[curr] = this.selectedUser[curr].trim();
        } else {
          acc[curr] = this.selectedUser[curr];
        }
        return acc;
      }, {});

      const data = { data: { ...copy } };
      editPermission(data).then((resp) => {
        console.log('Successfully POSTed');
        console.log(resp);
        this.$set(this.results, this.selectedIndex, copy);
        this.$nextTick(() => {
          this.$bvModal.hide('edit-user');
        });
      }).catch((err) => {
        console.log(err);
        this.error = true;
      });
    },
    selected(user) {
      console.log(user);
      this.selectedUser = JSON.parse(JSON.stringify(user));
      this.selectedUser.first = JSON.parse(JSON.stringify(user.firstName));
      this.selectedUser.last = JSON.parse(JSON.stringify(user.lastName));
      this.selectedIndex = this.results.findIndex((item) => (this.selectedUser.id === item.id));
    },
    checkFormValidity() {
      // this.userState.firstState = this.$refs.first.checkValidity();
      // this.userState.lastState = this.$refs.last.checkValidity();
      this.userState.emailState = this.$refs.email.checkValidity();
      // this.userState.passwordState = this.$refs.password.checkValidity();
      this.userState.roleState = this.$refs.role.checkValidity();
      this.userState.officeState = this.$refs.office.checkValidity();
      this.userState.titleState = this.$refs.title.checkValidity();
      let valid = true;
      Object.values(this.userState).forEach((value) => {
        if (value === false) {
          valid = false;
        }
      });

      return valid;
    },
    editFormValidity() {
      this.userState.firstState = this.$refs.first[0].checkValidity();
      this.userState.lastState = this.$refs.last[0].checkValidity();
      this.userState.emailState = this.$refs.email[0].checkValidity();
      this.userState.roleState = this.$refs.role[0].checkValidity();
      this.userState.officeState = this.$refs.office[0].checkValidity();
      this.userState.titleState = this.$refs.title[0].checkValidity();
      let valid = true;
      Object.values(this.userState).forEach((value) => {
        if (value === false) {
          valid = false;
        }
      });

      return valid;
    },
    searchResults() {
      this.results = this.fuse.search(this.search);
    },
    addUser(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.checkFormValidity()) {
        return;
      }
      const copy = Object.keys(this.user).reduce((acc, curr) => {
        if (typeof this.user[curr] === 'string') {
          acc[curr] = this.user[curr].trim();
        } else {
          acc[curr] = this.user[curr];
        }
        return acc;
      }, {});

      copy.name = `${copy.first} ${copy.last}`;
      // copy.email = copy.email.toLowerCase();
      delete copy.first;
      delete copy.last;

      const data = { data: { ...copy } };
      postUser(data).then((resp) => {
        console.log('Successfully POSTed');
        console.log(resp);
        this.results.push({ ...copy, id: resp.data.id, permissions: resp.data.permissions });
        this.$nextTick(() => {
          this.$bvModal.hide('new-user');
        });
      }).catch((err) => {
        console.log(err);
        this.error = true;
      });
    },
    edit(bvModalEvt) {
      bvModalEvt.preventDefault();
      if (!this.editFormValidity()) {
        return;
      }
      const copy = Object.keys(this.selectedUser).reduce((acc, curr) => {
        if (typeof this.selectedUser[curr] === 'string') {
          acc[curr] = this.selectedUser[curr].trim();
        } else {
          acc[curr] = this.selectedUser[curr];
        }
        return acc;
      }, {});

      // copy.name = `${copy.first} ${copy.last}`;
      // copy.email = copy.email.toLowerCase();
      // delete copy.first;
      // delete copy.last;

      const data = { data: { ...copy } };
      editUser(data).then((resp) => {
        console.log('Successfully POSTed');
        console.log(resp);
        this.$nextTick(() => {
          this.$bvModal.hide('edit-user');
        });
        this.$set(this.results, this.selectedIndex, resp.data.result);
      }).catch((err) => {
        console.log(err);
        this.error = true;
      });
    },
    remove() {
      const data = { data: { ...this.selectedUser } };
      deleteUser(data).then((resp) => {
        console.log('Successfully POSTed');
        console.log(resp);
        this.results = this.results.filter(
          (item) => item.email !== this.selectedUser.email,
        );
      }).catch((err) => {
        console.log(err);
      });
    },
    resend() {
      const data = { data: { ...this.selectedUser } };
      emailresend(data).then(() => {
        console.log('Successfully POSTed');
      }).catch((err) => {
        console.log(err);
      });
    },
    resetModal() {
      Object.keys(this.user).forEach((key) => {
        this.user[key] = '';
      });
      Object.keys(this.userState).forEach((key) => {
        this.userState[key] = null;
      });
      this.error = false;
    },
  },
  mounted() {
    // initializeFloatingLabels();
    getUser().then((resp) => {
      console.log('Successfully GETed');
      this.currentUser = JSON.parse(localStorage.getItem('user'));
      this.results = resp.data.result.filter((res) => (res.email !== this.currentUser.email));
    }).catch((err) => {
      console.log(err);
    });
    getOffice().then((resp) => {
      console.log('Successfully GETed');
      resp.data.result.forEach((item) => (
        this.officeOptions.push({ text: item.name, value: item.id })
      ));
      this.officeFlag = this.officeOptions.length <= 1;
      this.loading = false;
    }).catch((err) => {
      console.log(err);
    });
  },
  components: {
    Loading,
    PermissionAdmin,
    PermissionStaffExporter,
    PermissionStaffImporter,
    PermissionTransportSpecialistExporter,
    PermissionTransportSpecialistImporter,
  },
};
</script>

<style scoped lang="scss">
</style>
